export default {
  title: 'タイトル',
  description: '説明',
  strength: 'レベル',
};
